if (typeof HeroFadeSlider !== 'function') {

	class HeroFadeSlider extends HTMLElement {

		connectedCallback() {
			this.slides = Array.from(this.querySelectorAll('[data-slide]'));
			if (this.slides.length < 2) return;

			this.index = Math.max(0, this.slides.findIndex(slide => slide.hasAttribute('data-slide-active')));
			this.speed = parseInt(this.getAttribute('data-autoplay-speed'), 10) || 5000;

			this.querySelectorAll('[data-slide-prev]').forEach(button => {
				button.addEventListener('click', () => {
					this.goTo(this.index - 1, 'prev');
					this.restart();
				});
			});
			this.querySelectorAll('[data-slide-next]').forEach(button => {
				button.addEventListener('click', () => {
					this.goTo(this.index + 1);
					this.restart();
				});
			});

			this.syncNavColor();
			this.restart();
		}

		disconnectedCallback() {
			if (this.timer) clearInterval(this.timer);
		}

		goTo(newIndex, direction = 'next') {
			const total = this.slides.length;
			const nextIndex = ((newIndex % total) + total) % total;
			if (nextIndex === this.index) return;

			// Lets CSS run direction-aware enter/leave animations (used by the split slider)
			this.setAttribute('data-direction', direction);
			this.slides.forEach(slide => slide.removeAttribute('data-slide-leaving'));
			this.slides[this.index].setAttribute('data-slide-leaving', '');
			this.slides[this.index].removeAttribute('data-slide-active');
			this.slides[nextIndex].setAttribute('data-slide-active', '');
			this.index = nextIndex;
			this.syncNavColor();
		}

		syncNavColor() {
			const activeCard = this.slides[this.index].querySelector('.card');
			if (!activeCard) return;
			const color = getComputedStyle(activeCard).getPropertyValue('--color-scheme-text');
			if (color) this.style.setProperty('--color-scheme-text', color.trim());
		}

		restart() {
			if (this.timer) clearInterval(this.timer);
			this.timer = setInterval(() => {
				this.goTo(this.index + 1);
			}, this.speed);
		}

	}

	customElements.define('hero-fade-slider', HeroFadeSlider);

}
